/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'react',
	'ca-ui-toolkit',
	'prop-types'
], function(
	React,
	UI_Toolkit,
	PropTypes
) {

	const { Component } = React;
	const { SVGIcon } = UI_Toolkit;

	class CustomVisualsComponentHeader extends Component {

		componentDidMount() {
			const { customVisAction } = this.props;
			const { refreshCustomVisDefinitions } = this.props.handlers;
			customVisAction.createUploadFileNode(refreshCustomVisDefinitions);
		}

		componentWillUnmount() {
			const { customVisAction } = this.props;
			customVisAction.removeUploadFileNode();
		}

		render () {
			const { customVisAction } = this.props;
			const openSelectBundleFileDialog = customVisAction.openSelectBundleFileDialog.bind(customVisAction);
			const addNewIcon = customVisAction.dashboardApi.getFeature('Icons').getIcon('addNew');

			return (
				<SVGIcon
					size='small'
					className='svgIcon'
					verticalAlign='sub'
					iconId={addNewIcon.id}
					onClick={() => openSelectBundleFileDialog()}
				/>
			);
		}
	}
	CustomVisualsComponentHeader.propTypes = {
		handlers: PropTypes.shape({
			refreshCustomVisDefinitions: PropTypes.func.isRequired
		}).isRequired,
		customVisAction: PropTypes.object.isRequired
	};

	return CustomVisualsComponentHeader;
});
